export const IS_DEV = false;
export const GAME_VERSION = `149.5.0`;
export const REVISION_HASH = `43df9`;